<template>
  <div class="w-full">
    <div class="flex w-11/12 m-auto">
      <div class="flex items-end w-full sm:mb-0 sm:w-2/3">
        <h3>{{ reportname }} </h3>
      </div>
      <div class="w-full sm:mb-0 sm:w-1/2">
          <!-- Demo of filtering report list -->
          <div class="block text-right text-xxs text-green-600">Search By Title, Author, Psych Model, or Tag</div>
          <div class="flex">
            <i aria-hidden="true" class="material-icons bg-gray-500 text-white pt-1 px-1">search</i>
            <input type="text" v-model="filter" class="w-full text-sm py-1 px-2 leading-snug font-bold placeholder-gray-900 border-gray-500" placeholder="Search Available Report Chapters">
          </div>
      </div>
    </div>
    <div class="report-builder flex w-11/12 bg-gray-400 border-2 border-gray-500 pl-3">
      <div  class="w-full sm:mb-0 sm:w-2/3 md:border-r-8 md:border-gray-500 pr-3 py-3" style="max-height: 750px; overflow-y: scroll">
            <draggable :list="usedreports" animation="100" group="buildreport" tag="ul" @change="update" class="buildreport-side-a">
              <li v-for="(report, index) in usedreports" class="listbox flex">
                <div class="flex items-center inline-block w-6 justify-center bg-gray-200 flex-none cursor-move">{{ index + 1 }}</div>
                <span class="flex-grow align-middle py-2 cursor-move">
                  <div class="-mt-1 -mr-1 float-right">
                    <a v-if="profilelinks" class="text-xs pr-0" :href="'/users/'+userid+'/reportsections/'+report.id+''" target="_blank"><i aria-hidden="true" class="material-icons align-middle text-lg">visibility</i><i aria-hidden="true" class="material-icons align-middle text-xs ml-1">open_in_new</i></a>
                    <a v-else class="text-xs pr-0" :href="'/demoreportsections/'+report.id+''" target="_blank"><i aria-hidden="true" class="material-icons align-middle text-lg">visibility</i><i aria-hidden="true" class="material-icons align-middle text-xs ml-1">open_in_new</i></a>
                  </div>
                  <div class="align-middle text-base font-bold">{{ report.name }}</div>
                  <div v-if="annotations_by_section" class="mb-1 text-xs">
                    <span class="font-black font-mono inline-block text-black w-4 h-4 text-center bg-yellow-300 rounded-full">
                      {{ annotations_by_section[report.id] ? annotations_by_section[report.id].length : '0' }}
                    </span><span> Visible Polish Entries</span>
                  </div>
                  <div v-if="report.internal_notes" class="block text-xxs bg-yellow-200 p-1 px-3 -mx-2 mb-1">{{ report.internal_notes }}</div>
                  <div class="inline-block text-xxs leading-snug">
                      <p class="leading-tight text-xs text-gray-700 pb-1">{{ report.short_desc }}</p>
                      <template v-if="brandshow == 1">
                        <strong v-if="report.authors.length > 1">Authors: </strong>
                        <strong v-else>Author: </strong>
                        <span v-for="authors in report.authors" class="inline-block text-xxs mr-2 text-green-700">
                            {{ authors.first_name }} {{ authors.last_name }}
                        </span><br>
                        <strong v-if="report.psych_models.length > 1">Psych Models: </strong>
                        <strong v-else>Psyche Model: </strong><span v-for="psych_model in report.psych_models"  class="inline-block text-xxs mr-2 text-yellow-600">
                          {{ psych_model.name }}
                        </span><br>
                            <strong v-if="report.tags.length > 1">Tags: </strong>
                                <strong v-else>Tag: </strong><span v-for="tag in report.tags"  class="inline-block text-xxs mr-2 text-blue-500">
                          #{{ tag.name }}
                        </span>
                      </template>
                  </div>
                </span>
                  <div class="handle cursor-move flex items-center inline-block w-8 justify-center bg-gray-200 flex-none"><i aria-hidden="true" class="material-icons text-lg text-indigo-500">open_with</i></div>
              </li>
            </draggable>
      </div>

      <div class="w-full sm:mb-0 sm:w-1/2 px-3 py-3" style="max-height: 750px; overflow-y: scroll">

            <draggable :list="unusedreports" class="buildreport-side-b" animation="100" group="buildreport" tag="ul" handle=".handle">
              <li v-for="(report, index) in unusedreports" :key="report.id" class="mb-0">
                <div v-if="isInFilteredReports(report)" class="listbox flex">
                  <div class="handle cursor-move flex items-center inline-block w-6 flex-none justify-center bg-gray-100 bg-gray-300"><i aria-hidden="true" class="material-icons text-sm text-indigo-500">open_with</i></div>

                    <span class="flex-grow align-middle py-2">
                      <div class="-mt-1 -mr-1 float-right">
                        <a v-if="profilelinks" class="text-xs pr-0" :href="'/users/'+userid+'/reportsections/'+report.id+''" target="_blank"><i aria-hidden="true" class="material-icons align-middle text-lg">visibility</i><i aria-hidden="true" class="material-icons align-middle text-xs ml-1">open_in_new</i></a>
                        <a v-else class="text-xs pr-0" :href="'/demoreportsections/'+report.id+''" target="_blank"><i aria-hidden="true" class="material-icons align-middle text-lg">visibility</i><i aria-hidden="true" class="material-icons align-middle text-xs ml-1">open_in_new</i></a>
                      </div>
                      <div class="align-middle text-sm font-bold">{{ report.name }}</div>
                      <div v-if="annotations_by_section" class="mb-1 text-xxs">
                        <span class="font-black font-mono inline-block text-black w-3 h-3 text-center bg-yellow-300 rounded-full">
                          {{ annotations_by_section[report.id] ? annotations_by_section[report.id].length : '0' }}
                        </span><span class="text-gray-800"> Visible Polish Entries</span>
                      </div>
                      <div v-if="report.internal_notes" class="block text-xxs bg-yellow-200 p-1 px-2 -mx-2 mb-1">{{ report.internal_notes }}</div>
                      <div class="inline-block text-xxs leading-snug">
                          <p class="leading-tight text-gray-700 pb-1">{{ report.short_desc }}</p>
                          <template v-if="brandshow == 1">
                            <strong v-if="report.authors.length > 1">Authors: </strong>
                            <strong v-else>Author: </strong>
                            <span v-for="authors in report.authors" class="inline-block text-xxs mr-2 text-green-700">
                                {{ authors.first_name }} {{ authors.last_name }}
                            </span><br>
                            <strong v-if="report.psych_models.length > 1">Psych Models: </strong>
                            <strong v-else>Psyche Model: </strong><span v-for="psych_model in report.psych_models"  class="inline-block text-xxs mr-2 text-yellow-600">
                              {{ psych_model.name }}
                            </span><br>
                            <strong v-if="report.tags.length > 1">Tags: </strong>
                                <strong v-else>Tag: </strong><span v-for="tag in report.tags"  class="inline-block text-xxs mr-2 text-blue-500">
                              #{{ tag.name }}
                            </span>
                          </template>
                      </div>
                    </span>
                  </div>
              </li>
            </draggable>
      </div>

    </div>
  </div>
</template>

<script>
import VTooltip from 'v-tooltip'
import axios from 'axios'
import draggable from 'vuedraggable'

  export default {
    display: "Two Lists",
    order: 1,
      components: {
        draggable,
      },
        props: {
            reports: '',
            allreports: '',
            route:'',
            reportname: '',
            brandshow: '',
            profilelinks: '',
            userid:'',
            annotations_by_section: {
              default: '',
            },
        },
        data() {
          return {
            usedreports: this.reports,
            unusedreports: this.allreports,
            filter: '',
          }
        },
        computed: {
            filteredReports() {
              return this.filter
                ? this.unusedreports.filter(report => {
                  return report.name.toLowerCase().includes(this.filter.toLowerCase()) ||
                  // report.wizard_report_type.name.toLowerCase().includes(this.filter.toLowerCase()) ||
                  report.authors.some(author => {
                    return author.first_name.toLowerCase().includes(this.filter.toLowerCase()) ||
                    author.last_name.toLowerCase().includes(this.filter.toLowerCase());
                  })||
                  report.tags.some(tag => {
                      return tag.name.toLowerCase().includes(this.filter.toLowerCase()) ;
                  })||
                  report.psych_models.some(psych_model => {
                    return psych_model.name.toLowerCase().includes(this.filter.toLowerCase());
                  });
                })
                : this.unusedreports;
            },
        },
        methods: {
          isInFilteredReports(report) {
            return this.filteredReports.includes(report);
          },
          update() {
            axios.put(this.route, { id: this.usedreports.map(report => report.id) })
              .then(response => {
                this.$parent.$emit('updatedSelectedReports', this.usedreports);
              })
          },
        },
        created() {
          this.$parent.$emit('updatedSelectedReports', this.usedreports);
        },
      };
</script>
